
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.5 9.166h-1.667V7.5A.836.836 0 0010 6.667a.836.836 0 00-.833.833v1.666H7.5a.836.836 0 00-.833.834c0 .458.375.833.833.833h1.667V12.5c0 .458.375.833.833.833a.836.836 0 00.833-.833v-1.667H12.5a.836.836 0 00.833-.833.836.836 0 00-.833-.834zm-2.5 7.5A6.674 6.674 0 013.333 10 6.674 6.674 0 0110 3.333 6.674 6.674 0 0116.667 10 6.674 6.674 0 0110 16.666zm0-15c-4.595 0-8.333 3.739-8.333 8.334S5.405 18.333 10 18.333c4.595 0 8.333-3.738 8.333-8.333 0-4.595-3.738-8.333-8.333-8.333z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.5 9.166h-1.667V7.5A.836.836 0 0010 6.667a.836.836 0 00-.833.833v1.666H7.5a.836.836 0 00-.833.834c0 .458.375.833.833.833h1.667V12.5c0 .458.375.833.833.833a.836.836 0 00.833-.833v-1.667H12.5a.836.836 0 00.833-.833.836.836 0 00-.833-.834zm-2.5 7.5A6.674 6.674 0 013.333 10 6.674 6.674 0 0110 3.333 6.674 6.674 0 0116.667 10 6.674 6.674 0 0110 16.666zm0-15c-4.595 0-8.333 3.739-8.333 8.334S5.405 18.333 10 18.333c4.595 0 8.333-3.738 8.333-8.333 0-4.595-3.738-8.333-8.333-8.333z"}})])
          )
        }
      }
    